import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillDescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const BadgeWrapper = styled.div`
  margin-right: ${Spacing.S8};
`
